/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
const useStyles = theme => ({
  ctaContainer: {
    width: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      width: 'fit-content',
      margin: '0 auto',
    },
  },
  text: {
    p: 0,
    background: 'none',
    color: theme?.palette?.primary?.buttonColor,
    '&:hover': {
      background: 'transparent',
      color: theme?.palette?.primary?.buttonColor,
    },
  },
  outlined: {
    background: theme?.palette?.primary?.contrastText,
    border: `0.1875rem solid ${theme?.palette?.primary?.buttonColor}`,
    color: theme?.palette?.primary?.buttonColor,
    '&:hover': {
      background: theme?.palette?.primary?.buttonPrimaryHoverColor,
      color: theme?.palette?.primary?.contrastText,
      border: `0.1875rem solid ${theme?.palette?.primary?.buttonPrimaryHoverColor}`,
    },
  },
  contained: {
    p: '0.4rem 1.375rem',
    background: theme?.palette?.primary?.buttonColor,
    border: `0.1875rem solid ${theme?.palette?.primary?.buttonColor}`,
    color: theme?.palette?.primary?.contrastText,
    '&:hover': {
      background: theme?.palette?.primary?.buttonPrimaryHoverColor,
      color: theme?.palette?.primary?.contrastText,
      border: `0.1875rem solid ${theme?.palette?.primary?.buttonPrimaryHoverColor}`,
    },
  },
});
export default useStyles;
